import React from "react";
import clsx from "clsx";
import styles from "./ErrorModal.module.scss";
import { QQModal, SvgIcon } from ".";

export interface ErrorModalProps {
  title?: string;
  message: React.ReactNode;
  show: boolean;
  closeButton?: boolean;
  onClose?: () => void;
  /**
   * Optional override for the primary "Reload" action.
   * Defaults to a full page reload — appropriate for service/network errors.
   */
  onReload?: () => void;
  /**
   * When false, the primary "Reload page" button is hidden and only the
   * dismiss button is shown. Use for validation errors where reloading
   * wouldn't help.
   */
  showReload?: boolean;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  title,
  message,
  show,
  closeButton = true,
  onClose = () => {},
  onReload,
  showReload = true,
}) => {
  const handleReload = onReload ?? (() => window.location.reload());

  const titleNode = (
    <div className="d-flex align-items-center">
      <SvgIcon name="errorWhite" attributes={{ width: "18px", height: "18px" }} />
      <span className={clsx(styles.titleText, "ms-8")}>{title || "Error"}</span>
    </div>
  );

  const footerNode = (
    <>
      {closeButton && (
        <button
          type="button"
          className={clsx(styles.btnSecondary, "btn font-size-12 px-32 m-0")}
          onClick={onClose}
        >
          Close
        </button>
      )}
      {showReload && (
        <button
          type="button"
          className="btn btn-primary font-size-12 px-32 m-0 ms-8"
          onClick={handleReload}
        >
          Reload page
        </button>
      )}
    </>
  );

  return (
    <QQModal
      show={show}
      size="sm"
      closeButton={closeButton}
      onClose={onClose}
      centered
      backdrop={closeButton ? true : "static"}
      contentClassName={styles.modalContent}
      headerClassName={styles.modalHeader}
      bodyClassName={clsx(styles.modalBody, "bg-white font-size-13 px-20 py-24")}
      footerClassName={styles.modalFooter}
      title={titleNode}
      footer={footerNode}
    >
      <div className="text-center">{message}</div>
    </QQModal>
  );
};
